import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} UpdateLocaleResponse
 * @property {boolean} success
 * @property {string} message
 * @property {{ locale: "en" | "hi" | null }} data
 */

/**
 * Hook to update school language preference setting
 */
export const useUpdateLocale = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [result, setResult] = useState(
    /** @type {UpdateLocaleResponse | null} */ (null),
  );

  const { axiosInstance } = useAxios();

  /**
   * Update Language Preference
   * @param {object} params
   * @param {"en" | "hi" | null} params.locale
   * @param {()=> void} params.onSuccess
   * @param {(message:string)=> void} params.onError
   */
  const updateLanguagePreference = async ({ locale, onSuccess, onError }) => {
    try {
      setLoading(true);
      setError("");
      setResult(null);

      const url = `${TENANT_DOMAIN}/school/admin/settings/locale`;

      const response = await axiosInstance.put(url, {
        locale: locale,
      });
      onSuccess();

      setResult(response.data || null);
    } catch (err) {
      setResult(null);
      let firstErrorMessage = ERROR_MESSAGES.INTERNAL_SERVER;
      if (err?.response?.data?.errors) {
        firstErrorMessage = Object.values(err?.response?.data?.errors)[0][0];
      }

      if (err?.response?.status === 500) {
        firstErrorMessage = ERROR_MESSAGES.INTERNAL_SERVER;
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        if (!firstErrorMessage)
          firstErrorMessage =
            err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN;
        setError(
          firstErrorMessage ||
            err?.response?.data?.message ||
            ERROR_MESSAGES.UNKNOWN,
        );
      }
      console.log("FIRST error message" + firstErrorMessage);
      onError(firstErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    updateLanguagePreference,
    loading,
    error,
    result,
  };
};
